import { render, staticRenderFns } from "./Accuracy.vue?vue&type=template&id=38d67ffc&scoped=true&"
import script from "./Accuracy.vue?vue&type=script&lang=js&"
export * from "./Accuracy.vue?vue&type=script&lang=js&"
import style0 from "./Accuracy.vue?vue&type=style&index=0&id=38d67ffc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d67ffc",
  null
  
)

export default component.exports